// components/routes/MainAppRoute.tsx
import { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
import { Spin } from 'antd';
import useSession from '@hooks/useSession';
import styles from './RouteGuard.module.css';

interface MainAppRouteProps {
    readonly children: ReactNode;
}

function MainAppRoute({ children }: Readonly<MainAppRouteProps>) {
    const { isLoggedIn, isAdmin, isSuperAdmin, isManager, isUser, isOattRateOwner, isOattBillPreparer, isOattBillApprover, loading } = useSession();
    const isOattUser = isOattRateOwner || isOattBillPreparer || isOattBillApprover;

    if (loading) {
        return (
            <div className={styles.loadingContainer}>
                <Spin size="large" tip="Loading application...">
                    <div style={{ minHeight: 200 }} />
                </Spin>
            </div>
        );
    }

    if (!isLoggedIn) {
        return <Navigate to="/login" replace />;
    }

    if (isOattUser) {
        return <Navigate to="/oati" replace />;
    }

    if (!isAdmin && !isSuperAdmin && !isManager && !isUser) {
        return <Navigate to="/unauthorized" replace />;
    }

    return <>{children}</>;
}

export default MainAppRoute;
